import styles from './loader.module.css';
import React from 'react';
import { useSelector } from 'react-redux';

const AppLoader = () => {

    const isLoader = useSelector(state=>state.appLoaderReduer.isLoader);

    if (!isLoader) {
        return null;
    }

    return (
        <div id="apploader" className={styles.apploader}>
            <div className={styles.container}>
                <div className={styles.inner}>
                    <div></div>
                </div>
            </div>
        </div>
    )

}

export default AppLoader;